/** @ngInject */
export function appsObservationsConfig($stateProvider) {
  $stateProvider.state('app.observations', {
    templateUrl: 'app/views/common/uiview.html',
    abstract: true,
  })
}
